import React, { forwardRef } from 'react';

import { SearchSimilar } from '@videoblocks/react-icons';

import Tooltip from '../../../../../../builder-io/storyblocks-design-system/components/atoms/Tooltip/Tooltip';
import { StockItem } from '../../../../../../common/types/StockItemTypes';
import { useStockItemCompact } from '../hooks/useStockItemCompact';

export interface RelatedVideosButtonProps {
  stockItem: StockItem;
  onClick: () => void;
}

export const RelatedVideosButton = forwardRef(
  (
    { onClick }: RelatedVideosButtonProps,
    ref: React.Ref<HTMLButtonElement>
  ) => {
    const { containerRef } = useStockItemCompact();

    const button = (
      <div ref={containerRef} className="h-full inline-block">
        <Tooltip
          ref={ref}
          title="Related Video"
          trigger={
            <button
              onClick={onClick}
              className="bg-gray-900 h-full py-3 px-3 flex items-center text-white space-x-1.5 rounded-full cursor-pointer border-0 hover:bg-opacity-90 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-white"
              aria-label="Related Video"
            >
              <SearchSimilar className="fill-white h-4 w-4" />
            </button>
          }
        />
      </div>
    );

    return button;
  }
);
